import { render, staticRenderFns } from "./AccountTeaser.vue?vue&type=template&id=70a3e53e&scoped=true&"
import script from "./AccountTeaser.js?vue&type=script&lang=js&"
export * from "./AccountTeaser.js?vue&type=script&lang=js&"
import style0 from "./AccountTeaser.scss?vue&type=style&index=0&id=70a3e53e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3e53e",
  null
  
)

export default component.exports